<script>
  import Textfield from '@smui/textfield';
  import HelperText from '@smui/textfield/helper-text';
  import { onMount } from 'svelte';
  import * as yup from 'yup';
  import { basicData as schema } from './schemas.js';

  let { valid = $bindable(), fields = $bindable(), attemptCount = 0 } = $props();

  let errors = $state({ email: null, phone: null });
  let touched = $state(new Set());

  $effect(() => {
    valid = Object.keys(errors).filter(key => errors[key]).length === 0;
  });

  function validateField(fieldName) {
    try {
      schema.validateSyncAt(fieldName, fields);
      errors = { ...errors, [fieldName]: null };
    } catch (err) {
      errors = { ...errors, [fieldName]: err.message };
    }
  }

  const handleBlur = (f) => { touched = new Set([...touched, f]); validateField(f); };
  const handleInput = (f) => { validateField(f); };

  onMount(() => {
    Object.keys(fields).forEach(fieldName => validateField(fieldName));
  });

</script>

<form>
  <div class="row row-m1">
    {#key attemptCount}
      <div class="cell" class:field-shaking={attemptCount > 0 && errors.email}>
        <Textfield bind:value={fields.email}
          variant="outlined"
          type="email"
          label="E-mail"
          input$autocomplete="email"
          invalid={errors.email && (touched.has('email') || attemptCount > 0)}
          onblur={() => handleBlur('email')}
          oninput={() => handleInput('email')}>
          {#snippet helper()}<HelperText persistent invalid>{errors.email && (touched.has('email') || attemptCount > 0) ? errors.email : ''}</HelperText>{/snippet}
        </Textfield>
      </div>
    {/key}
    {#key attemptCount}
      <div class="cell" class:field-shaking={attemptCount > 0 && errors.phone}>
        <Textfield bind:value={fields.phone}
          variant="outlined"
          label="Telefon"
          invalid={errors.phone && (touched.has('phone') || attemptCount > 0)}
          input$autocomplete="tel"
          onblur={() => handleBlur('phone')}
          oninput={() => handleInput('phone')}>
          {#snippet helper()}<HelperText persistent invalid>{errors.phone && (touched.has('phone') || attemptCount > 0) ? errors.phone : ''}</HelperText>{/snippet}
        </Textfield>
      </div>
    {/key}
  </div>
</form>

<style>
  .field-shaking {
    animation: field-shake 0.35s ease;
  }

  @keyframes field-shake {
    0%, 100% { transform: translateX(0); }
    25%       { transform: translateX(-5px); }
    75%       { transform: translateX(5px); }
  }
</style>
